
import { Component, Vue } from "vue-property-decorator";
import { Settings } from "../../../core/services/configService";
import { CrudService } from "../../../core/services/crudService";
import store from "../../../core/store";
import { DateHelper } from "../../../core/helpers/dateHelper";
import CampDays from "./campDays.vue";
import { Camp } from "./campPage.vue";
import ScrollableBanner from "../scrollableBanner.vue";
import { Product } from "@shared/core/interfaces/product";
import { Format } from "@shared/core/helpers/formatHelper";

@Component({
  components: {
    CampDays,
    ScrollableBanner,
  },
})
export default class CampsBanner extends Vue {
  private camps: Camp[] = [];
  private images: unknown[] = [];

  async mounted() {
    this.setDefaultImages();
    this.loadCamps();
  }

  private setDefaultImages() {
    const context = require.context(
      "@/images/academy",
      false,
      /\.(png|jpe?g|webp|gif)$/
    );
    this.images = context.keys().map(context);
  }

  private async loadCamps() {
    const url = `${Settings.HostName}/api/publiccamps/list`;
    const data = await new CrudService().httpGet(url);
    if (data == null || !data.ok) {
      console.error("Crash");
      return;
    }
    const camps = data.model as Camp[];
    camps.forEach(camp => {
      if (camp.start) {
        const startDate = DateHelper.toDate(camp.start, DateHelper.systemFormat)!;
        camp.startStr = DateHelper.beautifyDate(DateHelper.toServerFormat(startDate), true, true, true, false);
      }
      if (camp.inscriptionStart) {
        const inscriptionStartDate = DateHelper.toDate(camp.inscriptionStart, DateHelper.systemFormat)!;
        camp.inscriptionStartStr = DateHelper.formatDate(inscriptionStartDate, store.state.settings.DateNoTimeFormat);
      }
      if (camp.inscriptionEnd) {
        const inscriptionEndDate = DateHelper.toDate(camp.inscriptionEnd, DateHelper.systemFormat)!;
        camp.inscriptionEndStr = DateHelper.formatDate(inscriptionEndDate, store.state.settings.DateNoTimeFormat);
      }
    });
    this.camps = camps;
  }

  private getImageCamps(name: string, index: number) {
    if (name !== undefined && name !== "" && name !== null) {
      return store.state.settings.Uploads + "/" + name;
    }
    return this.images[index % this.images.length];
  }

  private getPrice(pr: Product) {
    const price = store.state.settings.PriceWithTaxes ? pr.grossPrice : pr.netPrice;
    return Format.formatCurrency(price.toString());
  }
}
